import { format, addHours } from 'date-fns'
import { string, number } from 'prop-types'
import { Fragment } from 'react'
import { Conditional, kuiperClassNames } from '@opallabs/kuiper'
import './styles.scss'

const dateFormat = 'MMM d yyyy, h:mm a'
const formatEndDate = (takedownScheduledAt, timezoneDifference) => {
  if (!takedownScheduledAt) return null

  return `${format(
    addHours(new Date(takedownScheduledAt), timezoneDifference),
    dateFormat
  )}`
}
const formatEndDateUserTimezone = (takedownScheduledAt) => {
  if (!takedownScheduledAt) return null

  return `${format(new Date(takedownScheduledAt), dateFormat)}`
}

const HeaderDurationDetails = ({
  dayOffset = 0,
  duration,
  scheduledAt,
  scheduledAtTimezone,
  takedownScheduledAt,
  timezoneDifference = 0,
  userTimezone,
}) => {
  const scheduledAtDate = addHours(new Date(scheduledAt), timezoneDifference)

  const formatOffset = (dayOffset) => {
    if (dayOffset === 0) return null
    if (dayOffset === 1) return '1 day'
    return `${dayOffset} days`
  }

  return (
    <div className={kuiperClassNames('header-duration-details')}>
      <Conditional condition={duration || timezoneDifference || dayOffset > 0}>
        <Fragment>
          <Conditional condition={duration && duration !== '0 days'}>
            <h6>{`Content live for ${duration}`}</h6>
          </Conditional>
          <Conditional condition={dayOffset > 0}>
            <h6>{`Starts ${formatOffset(dayOffset)} after moment`}</h6>
          </Conditional>
          <Conditional condition={timezoneDifference}>
            <h6>
              {`${userTimezone} is ${Math.abs(timezoneDifference)}
              ${timezoneDifference === 1 ? ' hour ' : ' hours '}
              ${
                timezoneDifference > 0 ? 'behind' : 'ahead of'
              } ${scheduledAtTimezone}`}
            </h6>
          </Conditional>
          <h6>Scheduled start date</h6>
          <p>
            {scheduledAtTimezone}:{' '}
            {`${format(new Date(scheduledAtDate), dateFormat)}`}
          </p>
          <Conditional condition={timezoneDifference}>
            <p>
              {userTimezone}: {`${format(new Date(scheduledAt), dateFormat)}`}
            </p>
          </Conditional>
          <Conditional condition={duration}>
            <div>
              <h6>Scheduled end date</h6>
              <p>
                {scheduledAtTimezone}:{' '}
                {formatEndDate(takedownScheduledAt, timezoneDifference)}
              </p>
              <Conditional condition={timezoneDifference}>
                <p>
                  {userTimezone}:{' '}
                  {formatEndDateUserTimezone(takedownScheduledAt)}
                </p>
              </Conditional>
            </div>
          </Conditional>
        </Fragment>
      </Conditional>
    </div>
  )
}

HeaderDurationDetails.propTypes = {
  dayOffset: number,
  duration: string,
  scheduledAt: string,
  scheduledAtTimezone: string,
  takedownScheduledAt: string,
  timezoneDifference: number,
  userTimezone: string,
}

export default HeaderDurationDetails
